import r from"./_baseProperty.js";import o from"./_basePropertyDeep.js";import e from"./_isKey.js";import t from"./_toKey.js";var m=r,p=o,s=e,a=t;var f=function(r){return s(r)?m(a(r)):p(r)};export{f as default};
//# sourceMappingURL=property.js.map
